// NOTE: those constants are imported in @corva/dc-platform-shared
// TODO: fix imports in that package and remove those constants

export const LOCAL_STORAGE_APP_THEME_KEY = 'APP_THEME';
export const LOCAL_STORAGE_PDF_REPORT_VIEW_KEY = 'PDF_REPORT_VIEW';
